// src/auth/general/Login.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext'; // Adjust path as needed
import '../admin/Login.css'; // Add your CSS styles here

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login, userProfile } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { success, error } = await login(email, password);
            
            if (success) {
                // Check if user has admin privileges before redirecting
                if (userProfile && (userProfile.user_type === 'admin' || userProfile.user_type === 'support')) {
                    navigate('/admin'); // Redirect to admin dashboard
                } else {
                    // If not admin, redirect to regular dashboard
                    navigate('/dashboard');
                }
            } else {
                if (error) {
                    setError(error.message || 'Invalid Login Please Try Again');
                } else {
                    setError('Invalid Login Please Try Again');
                }
            }
        } catch (error) {
            console.error('Login failed:', error);
            setError('An unexpected error occurred. Please try again.');
        }
    };

    return (
        <div className="form-container">
            <h2>Login</h2>
            {error && <div className="error-alert">{error}</div>}
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                    />
                </div>
                <button type="submit" className="submit-button">Login</button>
            </form>
        </div>
    );
};

export default Login;
